import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import * as eAPI from '../src/yoteach2-gui/SubCompos/eAPI.js'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/register'
    },
    {
      path: '/register',
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue')
    },
    {
      beforeEnter: (to, from, next) => {
        if (eAPI.check()) {
          return next()
        } else {
          next('/')
        }
      },
      path: '/dashboard',
      component: () => import(/* webpackChunkName: "register" */ './views/Dashboard.vue')
    },
    {
      path: '/dev',
      component: () => import(/* webpackChunkName: "register" */ './views/dev.vue')
    },
    {
      path: '/view/:ownerID/:earthID/:intro',
      component: () => import(/* webpackChunkName: "register" */ './views/View.vue')
    }
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
